// extracted by mini-css-extract-plugin
export default {"summary":"index_summary__9qFwO","top":"index_top__ifYk-","item":"index_item__CDyak","label":"index_label__Kctem","num":"index_num__Gcd6O"};